import { ApiErrorTranslationKeys } from '@/lib/api/apiErrorTranslationKeys.ts';
import { isKnownBackendErrorKey } from '@/lib/api/exception.ts';

/**
 * Backend `TranslationKey` enum member names — see `hasErrorKey` for why the
 * dotted variant (`error.raw_transaction.ignored`) never matches.
 */
export const RawTransactionErrorKeys = {
  NOT_FOUND: 'RAW_TRANSACTION_NOT_FOUND',
  IGNORED: 'RAW_TRANSACTION_IGNORED',
  NOT_AN_INCOME: 'RAW_TRANSACTION_NOT_AN_INCOME',
  ALREADY_QUALIFIED: 'RAW_TRANSACTION_ALREADY_QUALIFIED',
  QUALIFIED_CANNOT_DELETE: 'RAW_TRANSACTION_QUALIFIED_CANNOT_DELETE',
  BOOKING_NOT_FOUND: 'BOOKING_NOT_FOUND',
} as const satisfies Record<string, keyof typeof ApiErrorTranslationKeys>;

const MATCH_TO_BOOKING_KEYS: (keyof typeof ApiErrorTranslationKeys)[] = [
  RawTransactionErrorKeys.NOT_FOUND,
  RawTransactionErrorKeys.IGNORED,
  RawTransactionErrorKeys.NOT_AN_INCOME,
  RawTransactionErrorKeys.ALREADY_QUALIFIED,
  RawTransactionErrorKeys.BOOKING_NOT_FOUND,
];

const DELETE_KEYS: (keyof typeof ApiErrorTranslationKeys)[] = [
  RawTransactionErrorKeys.QUALIFIED_CANNOT_DELETE,
  RawTransactionErrorKeys.NOT_FOUND,
];

const findMessage = (
  error: unknown,
  keys: (keyof typeof ApiErrorTranslationKeys)[],
): string | undefined => {
  const key = keys.find((candidate) =>
    isKnownBackendErrorKey(error, candidate),
  );
  return key ? ApiErrorTranslationKeys[key] : undefined;
};

/** Polski komunikat dla `match-to-booking`; `undefined` = nieznany błąd. */
export const getMatchToBookingErrorMessage = (
  error: unknown,
): string | undefined => findMessage(error, MATCH_TO_BOOKING_KEYS);

/**
 * Polski komunikat dla kasowania wierszy wyciągu; `undefined` = nieznany błąd.
 * Backend wkłada id blokującego przelewu w `errorMessage`, więc własny
 * komunikat jest czytelniejszy niż surowy tekst z backendu.
 */
export const getDeleteTransactionsErrorMessage = (
  error: unknown,
): string | undefined => findMessage(error, DELETE_KEYS);
